// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-list-item-wrapper.disabled .side-list-item[data-v-fcc33c44]:hover {
  cursor: not-allowed;
  background: none;
}
.contacts-list-item-wrapper.disabled .side-list-item.nohover[data-v-fcc33c44] {
  pointer-events: none;
  background-color: transparent;
}
.contacts-list-item-wrapper.disabled .side-list-item[data-v-fcc33c44] .marked {
  background-color: var(--contact-list-marked-bg);
}
.contacts-list-item-wrapper.nohover[data-v-fcc33c44] {
  width: 80%;
}
.moved[data-v-fcc33c44] {
  color: var(--elem-red-color);
}
.side-list-item[data-v-fcc33c44] {
  display: flex;
  width: 100%;
  align-items: center;
}
.side-list-item[data-v-fcc33c44]:hover {
  background-color: var(--list-item-bghover);
}
.side-list-item.nohover[data-v-fcc33c44] {
  pointer-events: none;
  background-color: transparent;
}
.side-list-item > *[data-v-fcc33c44]:not(:first-child) {
  margin: auto 0 auto 12px;
}
.side-list-item.chat-list-item + .hor-line[data-v-fcc33c44] {
  width: calc(100% - 68px);
  margin-left: 68px;
}
.side-list-item.contacts-list-item + .hor-line[data-v-fcc33c44] {
  width: calc(100% - 68px);
  margin-left: 68px;
}
.side-list-item.contacts-list-item + .hor-line.custom-separator[data-v-fcc33c44] {
  margin-left: 52px;
  width: 100%;
}
.side-list-item.compact .fio-block .name.name[data-v-fcc33c44],
.side-list-item.compact .text-block .name.name[data-v-fcc33c44],
.side-list-item.compact .fio-block .text.name[data-v-fcc33c44],
.side-list-item.compact .text-block .text.name[data-v-fcc33c44] {
  font-size: 1.2em;
}
.side-list-item .fio-block > *[data-v-fcc33c44],
.side-list-item .text-block > *[data-v-fcc33c44],
.side-list-item .right-block > *[data-v-fcc33c44] {
  display: flex;
}
.side-list-item .fio-block > * > *[data-v-fcc33c44],
.side-list-item .text-block > * > *[data-v-fcc33c44],
.side-list-item .right-block > * > *[data-v-fcc33c44] {
  margin: auto 0;
}
.side-list-item.selected[data-v-fcc33c44] {
  background-color: var(--list-item-activebgcolor);
}
.side-list-item .text-block[data-v-fcc33c44] {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  flex: 1 1;
}
.side-list-item .name.name[data-v-fcc33c44],
.side-list-item .text.name[data-v-fcc33c44] {
  font-size: var(--titleFontSize);
  filter: contrast(var(--fontContrast));
}
.side-list-item .name span[data-v-fcc33c44],
.side-list-item .text span[data-v-fcc33c44] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.side-list-item .sub-title[data-v-fcc33c44] {
  font-size: var(--subTitleFontSize);
  filter: contrast(var(--fontContrast));
}
.side-list-item .official[data-v-fcc33c44] {
  height: 14px;
  width: 14px;
  border-radius: 8px;
  background-color: var(--icon-bgcolor2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 10px;
  margin-left: 5px !important;
  flex-basis: 14px;
  min-width: 14px;
  min-height: 14px;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/listItems/ContactsListItem.vue"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".contacts-list-item-wrapper.disabled .side-list-item[data-v-fcc33c44]:hover {\n  cursor: not-allowed;\n  background: none;\n}\n.contacts-list-item-wrapper.disabled .side-list-item.nohover[data-v-fcc33c44] {\n  pointer-events: none;\n  background-color: transparent;\n}\n.contacts-list-item-wrapper.disabled .side-list-item[data-v-fcc33c44] .marked {\n  background-color: var(--contact-list-marked-bg);\n}\n.contacts-list-item-wrapper.nohover[data-v-fcc33c44] {\n  width: 80%;\n}\n.moved[data-v-fcc33c44] {\n  color: var(--elem-red-color);\n}\n.side-list-item[data-v-fcc33c44] {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n.side-list-item[data-v-fcc33c44]:hover {\n  background-color: var(--list-item-bghover);\n}\n.side-list-item.nohover[data-v-fcc33c44] {\n  pointer-events: none;\n  background-color: transparent;\n}\n.side-list-item > *[data-v-fcc33c44]:not(:first-child) {\n  margin: auto 0 auto 12px;\n}\n.side-list-item.chat-list-item + .hor-line[data-v-fcc33c44] {\n  width: calc(100% - 68px);\n  margin-left: 68px;\n}\n.side-list-item.contacts-list-item + .hor-line[data-v-fcc33c44] {\n  width: calc(100% - 68px);\n  margin-left: 68px;\n}\n.side-list-item.contacts-list-item + .hor-line.custom-separator[data-v-fcc33c44] {\n  margin-left: 52px;\n  width: 100%;\n}\n.side-list-item.compact .fio-block .name.name[data-v-fcc33c44],\n.side-list-item.compact .text-block .name.name[data-v-fcc33c44],\n.side-list-item.compact .fio-block .text.name[data-v-fcc33c44],\n.side-list-item.compact .text-block .text.name[data-v-fcc33c44] {\n  font-size: 1.2em;\n}\n.side-list-item .fio-block > *[data-v-fcc33c44],\n.side-list-item .text-block > *[data-v-fcc33c44],\n.side-list-item .right-block > *[data-v-fcc33c44] {\n  display: flex;\n}\n.side-list-item .fio-block > * > *[data-v-fcc33c44],\n.side-list-item .text-block > * > *[data-v-fcc33c44],\n.side-list-item .right-block > * > *[data-v-fcc33c44] {\n  margin: auto 0;\n}\n.side-list-item.selected[data-v-fcc33c44] {\n  background-color: var(--list-item-activebgcolor);\n}\n.side-list-item .text-block[data-v-fcc33c44] {\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n  flex: 1 1;\n}\n.side-list-item .name.name[data-v-fcc33c44],\n.side-list-item .text.name[data-v-fcc33c44] {\n  font-size: var(--titleFontSize);\n  filter: contrast(var(--fontContrast));\n}\n.side-list-item .name span[data-v-fcc33c44],\n.side-list-item .text span[data-v-fcc33c44] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.side-list-item .sub-title[data-v-fcc33c44] {\n  font-size: var(--subTitleFontSize);\n  filter: contrast(var(--fontContrast));\n}\n.side-list-item .official[data-v-fcc33c44] {\n  height: 14px;\n  width: 14px;\n  border-radius: 8px;\n  background-color: var(--icon-bgcolor2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  font-size: 10px;\n  margin-left: 5px !important;\n  flex-basis: 14px;\n  min-width: 14px;\n  min-height: 14px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
